<template>
  <div v-if="info">
    <div class="CompatibilityStatus" :class="resultContent.compatible ? '-compatible' : '-incompatible'" v-if="info.ALL_COMPATIBLE || info.COMPATIBLE_2 || info.COMPATIBLE_3 || info.COMPATIBLE_4 || info.COMPATIBLE_5 || info.COMPATIBLE_6 || info.INCOMPATIBLE || info.INVALID">
      <div class="_vehicle">
        {{info.vehicle}}
      </div>
      <div class="_summary">
        <img src="../../assets/thumbs-up.svg" alt="Thumbs up" :hidden="!resultContent.compatible">
        {{resultContent.summary}}
      </div>
      <div class="_details" v-html="resultContent.details"></div>
    </div>
    <div class="CompatibilityStatus -incompatible" v-if="info.NO_DATA">
      <div class="_vehicle">
        {{info.vehicle}}
      </div>
      <div class="_summary">
        Error.
      </div>
    </div>
    <div class="CompatibilityStatus -loading" v-if="info.loading === true">
      <div class="static">
        <div class="_vehicle-loading"></div>
        <div class="_summary-loading"></div>
        <div class="_details-loading"></div>
      </div>
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
  import content from "../../assets/stores.json"

  export default {
    name: 'CompatibilityStatus',
    props: ['info'],
    computed: {
      resultContent() {
        var resultContent = null

        if (this.info.ALL_COMPATIBLE) {
          resultContent = content.resultCompatible
          resultContent.compatible = true
        } else if (this.info.COMPATIBLE_2) {
          resultContent = content.resultIncompatible
          resultContent.compatible = false
        } else if (this.info.COMPATIBLE_3) {
          resultContent = content.resultCompatibleButCloseToControls
          resultContent.compatible = true
        } else if (this.info.COMPATIBLE_4) {
          resultContent = content.resultCompatibleButRequiresOpeningPanel
          resultContent.compatible = true
        } else if (this.info.COMPATIBLE_5) {
          resultContent = content.resultCompatibleButMayTouchLegs
          resultContent.compatible = true
        } else if (this.info.COMPATIBLE_6) {
          resultContent = content.resultCompatibleButCloseToControls
          resultContent.compatible = true
        } else {
          resultContent = content.resultIncompatible
          resultContent.compatible = false
        }

        if (this.$gtm.enabled()) {
          var result = resultContent.summary.replace(/\./g,'').toLowerCase();

          window.dataLayer?.push({
            'event': 'compatibility-checker-track-dimension',
            'event_category': 'Dimensions',
            'event_action': 'Compatibility Year/Make/Model',
            'event_label': this.info.eventLabel,
            'compatibility_year_make_model': this.info.eventLabel
          });

          window.dataLayer?.push({
            'event': 'compatibility-checker-track-dimension',
            'event_category': 'Dimensions',
            'event_action': 'Compatibility Result',
            'event_label': result,
            'compatibility_result' : result
          });
        }
        return resultContent
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/colors';
  @import '../../assets/spinner';

  .CompatibilityStatus {

    $border-width: 1px;

    border: $border-width solid $color-border-grey;
    padding: 35px 40px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: -$border-width;
      left: -$border-width;
      width: 3px;
      height: calc(100% + #{2 * $border-width});
    }

    &.-compatible::before {
      background-color: $color-vzc-green;
    }

    &.-incompatible::before {
      background-color: $color-vzc-orange;
    }

    ._vehicle {
      font-weight: bold;
      font-size: 20px;
    }

    ._summary {
      font-weight: bold;
      font-size: 62px;
    }

    ._details {
      font-size: 21px;
      max-width: 27em;
      p:first-child {
        margin-top: 0;
      }
      p:last-child {
        margin-bottom: 0;
      }
    }

    &.-loading {
      display: flex;
      justify-content: space-between;

      .static {
        flex: 1;

        > div {
          margin-top: 5px;
          background-image: linear-gradient(to right, #EEEFEF , #D8DADA);
        }
      }

      ._vehicle-loading {
        height: 30px;
        max-width: 15em;
      }

      ._summary-loading {
        height: 60px;
        max-width: 13em;
      }

      ._details-loading {
        height: 50px;
        max-width: 31em;
      }


      @media(max-width:479px) {
        padding: 25px 20px;
      }
    }
  }
</style>
